// Base64 SHA-256 of the file. Undefined where Web Crypto is unavailable (non-secure context, e.g. plain http on a non-localhost host).
export const hashFile = async (file: Pick<Blob, "arrayBuffer">): Promise<string | undefined> => {
  const subtleCrypto = globalThis.crypto?.subtle;

  if (!subtleCrypto) {
    return undefined;
  }

  try {
    const digest = await subtleCrypto.digest("SHA-256", await file.arrayBuffer());
    return btoa(String.fromCharCode(...new Uint8Array(digest)));
  } catch {
    // The hash is optional. Without it the API runs a new scan.
    return undefined;
  }
};
